import styled from 'styled-components';

export const SBrand = styled.div`
  display: flex;
  justify-content: center;
  margin: 8rem;
  cursor: pointer;
`;
